import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Page from "./Page";

/**
 * Layout component for authenticated routes.
 * Wraps all authenticated pages in a Page component with appropriate title and props
 * based on the current route.
 */
const AuthenticatedLayout: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  // Determine page configuration based on current route
  const getPageConfig = () => {
    const path = location.pathname;

    switch (path) {
      case "/":
        return { title: undefined, noBack: true };
      case "/printer-management":
        return { title: t("printer_management") };
      case "/master-control-station":
        return { title: t("master_control_station"), noCard: true };
      case "/done-order-view":
        return { title: t("completed_orders") };
      case "/order-lookup":
        return { title: t("order_lookup"), noCard: true };
      case "/order-lookup/results":
        return { title: t("order_lookup") };
      default:
        return { title: undefined };
    }
  };

  const pageConfig = getPageConfig();

  return (
    <Page title={pageConfig.title} noBack={pageConfig.noBack} noCard={pageConfig.noCard}>
      <Outlet />
    </Page>
  );
};

export default AuthenticatedLayout;
